import React from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';

/**
 * Fixed, full-viewport spray-paint background.
 *
 * The multi-colour spray (lime / lavender / rose / sky-blue / cream) is
 * PRE-BAKED into a single image (/spray-bg.jpg, grain included) so it composites
 * as ONE GPU layer — no per-frame CSS blur or mix-blend-mode repaint, which is
 * what made the old five-blob version stutter while scrolling.
 *
 * A gentle scroll-linked vertical parallax slides the taller-than-viewport image
 * so different colour regions drift into view as you scroll — smooth & cheap
 * (a single transform, GPU-composited).
 */
const SprayBackground = () => {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, { stiffness: 50, damping: 24, mass: 0.4 });
  const y = useTransform(smooth, [0, 1], ['0%', '-22%']);

  return (
    <div
      aria-hidden="true"
      data-testid="spray-background"
      className="fixed inset-0 overflow-hidden pointer-events-none"
      style={{ zIndex: 0 }}
    >
      <motion.div
        className="absolute inset-x-0 top-0 h-[130%]"
        style={{
          y,
          backgroundImage: 'url(/spray-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          willChange: 'transform',
        }}
      />
    </div>
  );
};

export default SprayBackground;
